<template lang="pug">
  .curriculum-form
    text-field(
      label="タイトル"
      v-model="forms.title"
      @input="onChange"
    )

    number-field(
      label="練習時間"
      unit="時間"
      :min="0"
      :max="99"
      :placeholder="0"
      v-model="forms.trainingHours"
      @input="onChange"
      @focus="forms.trainingHours = null"
    )

    curriculum-top-field(
      label="カリキュラムTOP"
      :curriculum="curriculum"
      v-model="topFields"
      @input="onChange"
      @upload="uploadStatusChanged"
    )

    curriculum-steps-field(
      v-model="steps"
      @input="onChange"
      @upload="uploadStatusChanged"
    )
</template>

<style lang="scss" scoped>
.input-field,
.curriculum-steps-field {
  margin-top: 16px;
}
</style>

<script>
import _ from 'lodash'
import TextField from '@/components/molecules/TextField'
import NumberField from '@/components/molecules/NumberField'
import CurriculumTopField from '@/components/organisms/CurriculumTopField'
import CurriculumStepsField from '@/components/organisms/CurriculumStepsField'
import SubmittableForm from '@/components/mixins/SubmittableForm'
import { CREATE_CURRICULUM, UPDATE_CURRICULUM } from '@/graphql'

export default {
  props: {
    curriculum: Object,
  },
  components: {
    TextField,
    NumberField,
    CurriculumTopField,
    CurriculumStepsField,
  },
  mixins: [SubmittableForm],
  data() {
    return {
      isUploading: false,
      forms: {
        title: _.get(this.curriculum, 'title'),
        trainingHours: _.get(this.curriculum, 'trainingHours'),
        description: _.get(this.curriculum, 'description'),
        videoKey: _.get(this.curriculum, 'video.videoKey'),
        thumbnailKey: _.get(this.curriculum, 'video.thumbnailKey'),
        steps: (_.get(this.curriculum, 'steps') || []).map((e) => {
          return {
            description: e.description,
            videoKey: e.video.videoKey,
            thumbnailKey: e.video.thumbnailKey,
            videoUrl: e.video.videoUrl,
            thumbnailUrl: e.video.thumbnailUrl,
          }
        }),
      },
    }
  },
  computed: {
    topFields: {
      get() {
        return _.pick(this.forms, ['description', 'videoKey', 'thumbnailKey'])
      },
      set(topFields) {
        this.updateValue(topFields)
      },
    },
    steps: {
      get() {
        return this.forms.steps
      },
      set(steps) {
        this.updateValue({ steps })
      },
    },
    isEditing() {
      return !!this.curriculum
    },
    variables() {
      return {
        curriculumId: _.get(this, 'curriculum.id'),
        title: this.forms.title,
        trainingHours: this.forms.trainingHours,
        description: this.forms.description,
        videoKey: this.forms.videoKey,
        thumbnailKey: this.forms.thumbnailKey,
        steps: this.forms.steps.map((e) => {
          return _.pick(e, ['description', 'videoKey', 'thumbnailKey'])
        }),
      }
    },
  },
  methods: {
    updateValue(diff) {
      this.forms = { ...this.forms, ...diff }
    },
    validate() {
      return (
        !this.isUploading &&
        !(
          _.isEmpty(this.forms.title) ||
          _.isNil(this.forms.trainingHours) ||
          _.isEmpty(this.forms.videoKey) ||
          _.isEmpty(this.forms.description)
        )
      )
    },
    async submit() {
      this.error.message = ''
      const mutator = this.isEditing
        ? UPDATE_CURRICULUM(this.variables)
        : CREATE_CURRICULUM(this.variables)
      await this.$apollo.mutate(mutator).catch(this.handleError)
    },
    uploadStatusChanged(isUploading) {
      this.isUploading = isUploading
      this.$emit('change', this.validate())
    },
  },
}
</script>
